module.exports = __webpack_public_path__ + "assets/img/img-photo.83b98c15.png";